export * from '@fhs/routing/src/routes/menu/(menu)/index';
export { default } from '@fhs/routing/src/routes/menu/(menu)/index';
